import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@material-ui/core';
//import CloseIcon from '@material-ui/icons/Close';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { StripeProvider, Elements, injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { itemService, globalService as gs, defaultService } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import moment from 'moment-timezone';
import { defaultActions, userActions } from '../../../common/redux/actions';
import { confirmAlert } from 'react-confirm-alert';

const handleBlur = () => {
    //console.log('[blur]');
};
const handleFocus = () => {
    //console.log('[focus]');
};
const handleReady = () => {
    //console.log('[ready]');
};


const createOptions = (fontSize, padding) => {
    return {
      style: {
        base: {
          fontSize,
          color: '#495057',
          fontWeight: '100',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#000',
          },
          padding,
        },
        invalid: {
          color: '#9e2146',
        },
      },
    };
};

class _CardForm extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            formField: {
                status: 1,
                comment: '',
                coupon_id: null,
                total: '',
                provider_id: '',
                start_time: '',
                items: [
                    {
                        price: '',
                        slot: '60',
                        start_time: '',
                        item_id: '',
                        quantity: 1,
                        child_id: '',
                        extra: {
                            topic: 'Create Meeting',
                            type: 2,
                            start_date: '',
                            duration: 60,
                            password: Math.random().toString(36).substring(5),
                            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                            agenda: ''
                        }
                    }
                ],
                token: { id: '', email: '' }
            },
            subject: '',
            error: '',
            slotList: [],
            isAvailable: '',
            couponCode: '',
            activeSlot: '',
            startDate: new Date(),
            loadingSlot: false,
            loading: false,
            loadingCouponCode: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentDidMount() {
        const { item, childs, dispatch } = this.props;
        const subjects = item && item.userProfile && item.userProfile.userCatalogs;
        let formField = {...this.state.formField};
        let items = formField.items;
        items[0].slot = 60;
        formField['provider_id'] = `${item.id}`;
        formField['items'] = items;
        this.setState({formField, subject: subjects && subjects[0] && subjects[0].provider_id});
        const subject = item && item.userProfile && item.userProfile.userCatalogs;
        //let start_time = moment(new Date() / 1000).valueOf();
        const d = new Date();
        let start_time = moment(d.setDate(d.getDate() + 1) / 1000).valueOf();
        this.loadSlots(item.user_id, (formField.items.id ? formField.items.id : subjects && subject[0].id), start_time);
        dispatch(userActions.child());

        //Team2 : for date selection calendar
        var newDate = new Date(Date.now() + 1*24*60*60*1000);
        this.updateSlots(newDate);
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({formField});
    };

    handleSubject = (e) => {
        const { name, value } = e.target;
        const { item } = this.props;
        const subjects = item && item.userProfile && item.userProfile.userCatalogs;
        const subject = subjects.filter(v => parseInt(v.id) === parseInt(value));
        let formField = {...this.state.formField};
        let items = formField.items;
        items[0].price = subject[0].price;
        items[0].item_id = `${subject[0].id}`;
        formField['total'] = subject[0].price;
        this.setState({formField, subject: subject[0].id}, () => {
            let start_time = moment(this.state.startDate / 1000).valueOf();
            this.loadSlots(item.id, (formField.items.id ? formField.items.id : subjects && subject[0].id), start_time);
        });
        //console.log('name, value', name, value, subject);
    }

    handleChilds = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        let items = formField.items;
        items[0].child_id = value;
        this.setState({formField});
    }

    handleError = (change) => {
        if(change.complete) this.setState({error: ''});
    };

    handleSlot = (slot, activeSlot) => {
        let formField = {...this.state.formField};
        let items = formField.items;
        items[0].start_time = slot;
        formField['items'] = items;
        formField['start_time'] = slot;
        this.setState({activeSlot, formField})
    }

    updateSlots = (date) => {
        const { item } = this.props;
        const { formField } = this.state;
        const subject = item && item.userProfile && item.userProfile.userCatalogs;
        this.setState({startDate: date});
        this.loadSlots(item.id, (formField.items.id ? formField.items.id : subject[0].id), (date / 1000));
    }

    loadSlots = (user_id = null, item_id = null, start_time = null) => {
        const { dispatch } = this.props;
        this.setState({loadingSlot: true});
        itemService.availability("GET", null, {user_id: user_id, item_id: item_id, start_time: start_time, slot: 60}).then(data => {
            let isAvailable = data.isAvailable;
            let slots = data.slots ? data.slots : [];
            let loadingSlot = false; // items per chunk
            this.setState({...this.state, isAvailable, slotList: slots, loadingSlot });
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loadingSlot: false});
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.state.formField);
        //return false;
        if( this.validator.allValid() ) {
            this.setState({loading: true});
            const { stripe, authentication, item } = this.props;
            const { user } = authentication && authentication.authentication && authentication.authentication;
            const subjects = item && item.userProfile && item.userProfile.userCatalogs;
            let formField = {...this.state.formField};
            const subject = subjects.filter(v => parseInt(v.id) === parseInt(formField.items[0].item_id));
            formField.items[0].extra.agenda = `Meeting for study ${subject[0].title}`;
            formField.items[0].extra.start_date = moment(formField.items[0].start_time * 1000).format();
            // console.log('subject[0].title', formField);
            if (Number(subject[0].price) > 0) {
                if(stripe) {
                    stripe.createToken({price: formField.total, name: user.name, email: user.email}).then((payload) => {
                        console.log('payload', payload)
                        if(payload && payload.token) {
                            formField['token'].id = payload.token.id;
                            formField['token'].email = payload.token.email;
                            this.bookTutor(formField);
                        } else {
                            const { dispatch } = this.props;
                            console.log("Stripe.js hasn't loaded yet.");
                            this.setState({loading: false, error: payload.error.message});
                            dispatch(alertSelectors.error(payload.error.message));
                        }
                    }, (error) => {
                        this.setState({loading: false, error: error.error.message});
                    });
                }
            } else {
                this.bookTutor(formField);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    bookTutor = (formField) => {
        const { dispatch } = this.props;
        itemService.booking("POST", {UserCatalogOrders: formField}).then(data => {
            this.setState({loading: false});
            //console.log('datadata', data);
            if(data.code) {
                dispatch(alertSelectors.success('You have successfully book this service'));
                const userCatalogOrdersRecipients = data.model.userCatalogOrdersRecipients;
                const recipients = userCatalogOrdersRecipients.map(item => { return item.recipient_id });
                //console.log('recipients', recipients);
                gs.isNotified(recipients);
                this.handleClose('done');
            } else {
                dispatch(alertSelectors.error(data.message));
            }
        }).catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    totalAmount = () => {
        const { config } = this.props.config;
        const { formField } = this.state;
        let price = formField.items[0].price;
        //const transaction_fee = config && config.transaction_fee;
        const transaction_fee = 0;
        if(price && price) {
            const tax = parseFloat(price) * parseFloat(transaction_fee) / 100;
            return (parseFloat(price) + parseFloat(tax)).toFixed(2);
        } else {
            return 'Select Subject';
        }
    }

    applyCouponCode = () => {
        const { dispatch, item } = this.props;
        if(this.state.couponCode.length < 1) return true;
        this.setState({loadingCouponCode: true});
        defaultService.coupons("GET", null, {code: this.state.couponCode}).then(data => {
            this.setState({loadingCouponCode: false});
            if(data.model !== null) {
                let formField = {...this.state.formField};
                let code = data.model;
                let old_price = (parseFloat(formField.items[0].price)).toFixed(2);
                let discount = code.discount;
                let discount_price = '';
                formField['coupon_id'] = code.id;
                if(code.type === 'fixed') {
                    discount_price = parseFloat(discount).toFixed(2);
                } else {
                    const percentage = (old_price * discount / 100);
                    discount_price = parseFloat(percentage).toFixed(2);
                }
                formField['total'] = (parseFloat(old_price) - parseFloat(discount_price)).toFixed(2);
                this.setState({formField, discount_price});
                dispatch(alertSelectors.success('Coupon code apply'));
            }
            else {
                confirmAlert({
                    message: 'Coupon code not valid.',
                    buttons: [
                        {
                            label: 'Ok',
                            onClick: () => console.log('No')
                        }
                    ]
                });
            }
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loadingCouponCode: false});
        });
    }

    handleClose = (e = null) => this.props.handleClose(e);

    render() {
        this.validator.purgeFields();
        const { formField, loading, startDate, loadingSlot, isAvailable, slotList, activeSlot, subject, loadingCouponCode, discount_price } = this.state;
        const { item, childs } = this.props;
        const subjects = item && item.userProfile && item.userProfile.userCatalogs;
        const d = new Date();
        const childsList = childs && childs.childs;
        //const transaction_fee = config.config;

        return (<form name="form" onSubmit={this.handleSubmit} noValidate>
            <div className="mb-3 d-flex justify-content-center">
                <DatePicker
                    disabled={false}
                    minDate={d.setDate(d.getDate() + 1)}
                    selected={startDate}
                    onChange={date => this.updateSlots(date)}
                    inline
                />
            </div>
            <div className="slots">
                {loadingSlot ? <div className="text-center p-3"><div className="spinner-border text-info"></div></div> :
                <ul>
                    {slotList && Object.entries(slotList).map(([key, value]) =>
                        <li key={`wer-${value}`} onClick={() => this.handleSlot(key, value)} className={(value === parseInt(activeSlot)) ? 'active' : ' '}>
                            <span className="badge badge-secondary">
                                {moment(value * 1000).format('LT')} - {moment(value * 1000).add(60, 'minutes').format('LT')}
                            </span>
                        </li>
                    )}
                    <li className="m-0 w-100">
                        {(isAvailable && isAvailable === false) && 'Service not available'}
                        {(slotList && slotList.length === 0) && 'Service not available'}
                        {this.validator.message('start_time', formField.items[0].start_time, 'required')}
                    </li>
                </ul>}
            </div>
            <div className="card-details">
                 <h3 className="font-weight-bold">Subject</h3>
            </div>
            <div className="subject form-group">
                <select className="custom-select form-control" name="subject" value={this.state.subject && this.state.subject.id} onChange={this.handleSubject}>
                    <option selected>Select Subject</option>
                    {subjects && subjects.map(sub => <option key={`sub${sub.id}`} value={sub.id}>{sub.title} ${sub.price}</option>)}
                </select>
                {this.validator.message('subject', subject, 'required')}
            </div>
            <div className="subject form-group">
                <label>Childs</label>
                <select className="custom-select form-control" name="child_id" value={formField.items[0].child_id} onChange={this.handleChilds}>
                    <option selected>Select Child</option>
                    {childsList && childsList.map(sub => <option key={`child${sub.id}`} value={sub.id}>{sub.name}</option>)}
                </select>
                {this.validator.message('child_id', formField.items[0].child_id, 'required')}
            </div>
            <div className="subject form-group">
                <label>Apply Coupon</label>
                <div className="input-group">
                    <input type="text" name="couponCode" className="form-control" value={this.state.couponCode} onChange={(e) => this.setState({couponCode: e.target.value})} />
                    <div className="input-group-append">
                        <button className="btn btn-secondary" type="button" onClick={this.applyCouponCode}>Apply {loadingCouponCode && <span className="spinner-border spinner-border-sm"></span>}</button>
                    </div>
                </div>
            </div>
            <div className="subject form-group">
                {/* <p><b>Transaction Fee:</b> {transaction_fee && transaction_fee.transaction_fee}%</p>  discount_price */}
                <p><b>Discount:</b> {discount_price ? discount_price : '00.00'}</p>
                <b>Total Amount:</b> <big>{(parseFloat(this.totalAmount() ? this.totalAmount() : 0) - parseFloat(discount_price ? discount_price : 0)).toFixed(2)}</big>
            </div>
            {(Number(formField.total) > 0) &&
            <div className="card-details">
                <h3 className="font-weight-bold">Payment Detail</h3>
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Card number</label>
                            <CardNumberElement
                                onBlur={handleBlur}
                                onChange={this.handleError}
                                onFocus={handleFocus}
                                onReady={handleReady}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Name of card holder</label>
                            <input type="text" className="form-control" />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Expiration date</label>
                            <CardExpiryElement
                                onBlur={handleBlur}
                                onChange={this.handleError}
                                onFocus={handleFocus}
                                onReady={handleReady}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>CVC</label>
                            <CardCVCElement
                                onBlur={handleBlur}
                                onChange={this.handleError}
                                onFocus={handleFocus}
                                onReady={handleReady}
                                placeholder={''}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                </div>
                {(this.state.error) && <div className="valid-feedback d-block text-danger form-group">{this.state.error}</div>}
            </div>}

            <div className="form-group">
                {/* <button onClick={this.handleClose} type="button" className="btn btn-info">Cancel </button> */}
                <LaddaButton type="submit" className="btn btn-secondary text-white text-uppercase" loading={loading} data-style={EXPAND_RIGHT}>BOOK NOW</LaddaButton>
            </div>
        </form>)
    }
}

const CardForm = injectStripe(_CardForm);

class BookTutor extends Component {

    handleClose = (e = null) => this.props.handleClose(e);

    componentDidMount() {
        const { dispatch, config } = this.props;
        (config.config === null) && dispatch(defaultActions.config());
    }

    render() {
        const { open, item, dispatch, authentication, config, childs } = this.props;
        //console.log('this.props', this.props)
        return (<Dialog onClose={this.handleClose} open={open} className="booking-dialog" scroll={"body"}>
            <DialogTitle id="simple-dialog-title" disableTypography className="bg-info text-white text-center">
                <Typography variant="h6">Book Tutor</Typography>
                <IconButton aria-label="close" className="closeButton" onClick={this.handleClose}>
                <i className="fas fa-times"></i>
                </IconButton>
            </DialogTitle>
            <DialogContent >
                <StripeProvider apiKey={process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY}>
                    <Elements>
                        <CardForm fontSize="16px" item={item && item} dispatch={dispatch} authentication={authentication && authentication} config={config} handleClose={(e) => this.handleClose(e)} childs={childs} />
                    </Elements>
                </StripeProvider>
            </DialogContent>
        </Dialog>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const processSelector = createSelector(
    state => state.process,
    process => process
);

const configSelector = createSelector(
    state => state.config,
    config => config
);

const childsSelector = createSelector(
    state => state.childs,
    childs => childs
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    configSelector,
    childsSelector,
    (process, authentication, config, childs) => ({
        process, authentication, config, childs
    })
);

export default connect(mapStateToProps)(BookTutor);
